import Vue from "vue";
import store from "@/store";
import Router from "vue-router";
// Main Home
// import HomeRoot from "@/views/Home/HomeRoot";
// import Home from "@/views/Home/Home";
// import Services from "@/views/Home/Services";
// import Partners from "@/views/Home/Partners";
//Documentation
import Documentation from "@/views/Documentation/Documentation";
import DocumentationHome from "@/views/Documentation/Home";
import DocumentationApi from "@/views/Documentation/ApiOrders";
import MercadoFlex from "@/views/Documentation/MercadoFlex";

//Demo
import Demo from "@/views/Demo/Home";
import DemoOrders from "@/views/Demo/DemoOrders";
import DemoList from "@/views/Demo/DemoList";
import DemoDetail from "@/views/Demo/DemoDetail";

// Dashboard
import Dashboard from "@/views/Dashboard/Dashboard";
import TrackingStatus from "@/views/tracking/TrackingStatus";

// Auth
import AuthCustomer from "@/views/Auth/AuthCustomer";
import AuthOptions from "@/views/Auth/AuthOptions";
import AuthLogin from "@/views/Auth/AuthLogin";
import AuthRegister from "@/views/Auth/AuthRegister";
// Integration
// import MainView from "@/views/Integration/MainView";
// import Integration from "@/views/Integration/Integration";
// import FlexIntegration from "@/views/Integration/FlexIntegration";

const PasswordChange = () =>
  import(
    /* webpackChunkName: "view-[request]" */ "@/views/Auth/AuthPasswordChange.vue"
  );

Vue.use(Router);
function loadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/views/Dashboard/${view}.vue`
    );
}
export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } 
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      beforeEnter: requireGuest,
      component: AuthCustomer,
      children: [
        {
          path: "",
          name: "home",
          component: AuthOptions,
        },
      ],
    },
    {
      path: "/auth",
      component: AuthCustomer,
      children: [
        {
          path: "",
          name: "auth",
          component: AuthOptions,
          beforeEnter: requireGuest,
        },
        {
          path: "register",
          name: "register",
          component: AuthRegister,
          beforeEnter: requireGuest,
        },
        {
          path: "login",
          name: "login",
          component: AuthLogin,
          beforeEnter: requireGuest,
        },
        {
          path: "logout",
          name: "Logout",
          beforeEnter: logout,
        },
        {
          path: "password-change/:token",
          name: "PasswordChange",
          component: PasswordChange,
          beforeEnter: requireGuest,
          props: true,
        },
      ],
    },
    {
      path: "/developers",
      component: Documentation,
      children: [
        {
          path: "",
          name: "api",
          component: DocumentationHome,
        },
        {
          path: "api-orders",
          name: "api-orders",
          component: DocumentationApi,
        },
        {
          path: "mercado-flex",
          name: "mercado-flex",
          component: MercadoFlex,
        },
      ],
    },
    {
      path: "/demo",
      component: Demo,
      children: [
        {
          path: "",
          name: "DemoOrders",
          component: DemoOrders,
        },
        {
          path: "ordenes-creadas",
          name: "DemoList",
          component: DemoList,
        },
        {
          path: "orders/:id",
          name: "DemoDetail",
          component: DemoDetail,
        },
      ],
    },
    {
      path: "/tracking",
      component: TrackingStatus,
      children: [
        {
          path: "?order=id",
          name: "TrackingStatus",
          component: TrackingStatus,
        },
      ],
    },
    // {
    //   path: "/integration",
    //   beforeEnter: requireAuth,
    //   component: MainView,
    //   children: [
    //     {
    //       path: "",
    //       name: "integration",
    //       component: Integration,
    //     },
    //     {
    //       path: "flex-int",
    //       name: "flex-int",
    //       component: FlexIntegration,
    //       children: [
    //         {
    //           path: "?code=id",
    //           component: FlexIntegration,
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      path: "/dashboard",
      beforeEnter: requireAuth,
      component: Dashboard,
      children: [
        {
          path: "",
          name: "selectservices",
          component: loadView("SelectServices"),
        },
        {
          path: "/select-services",
          component: loadView("SelectServices"),
        },
        {
          path: "neworder",
          redirect: { name: "nextday" },
        },
        {
          path: "newnextday",
          name: "nextday",
          component: loadView("NewNextDay"),
        },
        {
          path: "newsameday",
          name: "sameday",
          component: loadView("NewSameDay"),
        },
        {
          path: "newexpress",
          name: "express",
          component: loadView("NewExpress"),
        },
        {
          path: "profile",
          name: "profile",
          component: loadView("Profile"),
        },
        {
          path: "tracking",
          name: "tracking",
          component: loadView("Tracking"),
        },
        {
          path: "newmercadoflex",
          name: "mercadoflexview",
          component: loadView("NewMercadoFlex"),
        },
        {
          path: "tracking-express",
          name: "trackingExpress",
          component: loadView("TrackingExpress"),
        },
        // {
        //   path: 'charts',
        //   name: 'charts',
        //   component: loadView('Charts')
        // },
        {
          path: "reports",
          name: "reports",
          component: loadView("Reports"),
        },
      ],
    },
  ],
});

function requireAuth(to, from, next) {
  if (!store.getters.loggedIn) {
    next({ name: "auth", query: { redirect: to.fullPath } });
  } else {
    next();
  }
}

function requireGuest(to, from, next) {
  if (store.getters.loggedIn) next({ path: "/dashboard" });
  else next();
}

function logout(to, from, next) {
  store.commit("LOGOUT");
  next({ name: "login" });
}
